import { Component, Input } from '@angular/core';
import { HeroContent } from '../../../shared/model/store.models';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'clearcals-store-header',
  templateUrl: './store-header.component.html',
  styleUrls: ['./store-header.component.scss']
})
export class StoreHeaderComponent {
  @Input() heroContent$ = new BehaviorSubject<HeroContent | null>(null);

  constructor() { }

  getHighlightedText(text: string, highlights: string[]): { part: string, isHighlight: boolean }[] {
    const parts = text.split(new RegExp(`(${highlights.join('|')})`, 'g'));
    return parts.map(part => ({
      part,
      isHighlight: highlights.includes(part)
    }));
  }

  isViewportLessThan600px(): boolean {
    return window.innerWidth < 600;
  }
}
